"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // reminder to not import AppUI to avoid circular dependencies
var UrlBuilder = /*#__PURE__*/function () {
  function UrlBuilder(config) {
    _classCallCheck(this, UrlBuilder);
    if (config) {
      this.config = config;
      this.prefix = config.prefix;
    }
  }
  return _createClass(UrlBuilder, [{
    key: "build",
    value: function build(url, params) {
      return this.buildUrl(url, params);
    }
  }, {
    key: "buildFromUrls",
    value: function buildFromUrls(verb, action, params) {
      var url = this.getUrl(verb, action, params);
      if (url) {
        return this.buildUrl(url, params);
      }
      return null;
    }
  }, {
    key: "getUrl",
    value: function getUrl(verb, action, params) {
      var url;
      if ((0, _lodash.isFunction)(this.config)) {
        url = this.config(params)[verb];
      } else if ((0, _lodash.isObject)(this.config)) {
        url = this.config[verb];
      }
      if (action && url) {
        url = url[action];
      }
      return url;
    }
  }, {
    key: "normalizeUrl",
    value: function normalizeUrl(url) {
      return url[0] === '/' ? url : "/".concat(url);
    }
  }, {
    key: "buildUrl",
    value: function buildUrl(url) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var prefix = this.prefix || '/api';
      var path = "".concat(encodeURI(prefix)).concat(encodeURI(this.normalizeUrl(url)));
      var queryParams = new URLSearchParams();
      Object.keys(params || {}).forEach(function (key) {
        var value = params[key];
        if (value === null || typeof value === 'undefined') return;
        var symbolRegex = new RegExp(":".concat(key, "(?=[^A-Za-z0-9_]|$)"));
        var newPath = path.replace(symbolRegex, encodeURIComponent(String(value)));
        if (newPath === path) {
          queryParams.append(key, value);
        } else {
          path = newPath;
        }
      });
      var queryString = queryParams.toString();
      return queryString ? "".concat(path, "?").concat(queryString) : path;
    }
  }]);
}();
var _default = exports["default"] = UrlBuilder;